const addParticipants = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        addingParticipants: true,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        addingParticipants: false,
      };
    default:
      return state;
  }
};

export default addParticipants;
